import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../supplierLedgerSlice";
import { fetchSupplierLedger, searchSuppliers } from "../supplierLedgerThunk";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import { currentDateEndTime, currentDateStartTime } from "../../../../lib/functions";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const SupplierLedgerFilters = ({ messageApi }) => {
    const dispatch = useDispatch();
    const { filters } = useSelector((state) => state.supplierLedger);
    const { searchResults, loadingSearch } = useSelector((state) => state.supplierLedger);

    useDefaultDateRange(setFilters, filters, "today");

    const handleSearchSuppliers = useCallback(
        (text) => {
            dispatch(searchSuppliers(text));
        },
        [dispatch]
    );

    const handleFilterChange = (field, value) => {
        dispatch(setFilters({ [field]: value }));
    };

    const handleReport = () => {
        if (!filters.supplierId) {
            messageApi.warning("Select Supplier");
            return;
        }

        if (!filters.fromDate || !filters.toDate) {
            messageApi.warning("Select Date Range");
            return;
        }

        const payload = {
            supplierId: filters.supplierId,
            fromDate: filters.fromDate,
            toDate: filters.toDate,
        };

        dispatch(fetchSupplierLedger(payload)).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                messageApi.success("Ledger loaded ✅");
            } else {
                messageApi.error("Failed to fetch ledger ❌");
            }
        });
    };

    return (
        <Card className="mb-4 shadow-md rounded-xl">
            <Row gutter={16} style={{ alignItems: "center" }}>
                <Col span={6}>
                    <label>Search Supplier</label>
                    <SearchListAutoComplete
                        entityType="supplier"
                        searchThunk={handleSearchSuppliers}
                        resultSelector={(state) => state.supplierLedger.searchResults}
                        loading={loadingSearch}
                        onSelect={(obj) => {
                            if (!obj) {
                            // cleared
                            handleFilterChange("supplierId", null);
                            handleFilterChange("supplierName", "");
                            return;
                            }

                            handleFilterChange("supplierId", obj.acc_id);
                            handleFilterChange("supplierName", obj.acc_name);
                        }}
                        placeholder="Supplier"
                        showAddNew={false}
                    />
                </Col>

                <CommonDateRangeFilter
                filters={filters}
                onChange={(fromDate, toDate) => {
                    handleFilterChange("fromDate", fromDate);
                    handleFilterChange("toDate", toDate);
                }}
                />

                <Col span={4} style={{ display: "flex", alignItems: "flex-end", height: 58 }}>
                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={handleReport}
                        block
                        style={{height: 35.19}}
                        data-testid="report-btn"
                    >
                        Report
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

export default SupplierLedgerFilters;